import { webHeaders } from "../config";
import { clearSession, setSession } from "./session";

let inflight: Promise<boolean> | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;

/**
 * Exchanges the refresh cookie for a new access token. Concurrent callers
 * share one request (a burst of 401s triggers a single refresh). Resolves
 * false when there is no valid session.
 */
export function refreshSession(): Promise<boolean> {
  inflight ??= doRefresh().finally(() => {
    inflight = null;
  });
  return inflight;
}

async function doRefresh(): Promise<boolean> {
  try {
    const res = await fetch("/v1/auth/refresh", {
      method: "POST",
      credentials: "same-origin",
      headers: { ...webHeaders(), "content-type": "application/json" },
      body: "{}",
    });
    if (!res.ok) {
      clearSession();
      return false;
    }
    const body = (await res.json()) as { access_token: string; expires_in: number };
    acceptTokens(body.access_token, body.expires_in);
    return true;
  } catch {
    // Network failure: keep any current session, the next request retries.
    return false;
  }
}

/** Stores a fresh access token and refreshes it a minute before it expires. */
export function acceptTokens(accessToken: string, expiresInSeconds: number): void {
  setSession(accessToken);
  clearTimeout(timer);
  const delay = Math.max(10, expiresInSeconds - 60) * 1000;
  timer = setTimeout(() => void refreshSession(), delay);
}

export function stopRefreshTimer(): void {
  clearTimeout(timer);
}
